import React from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import RangeShootingReasonForm from '../../../components/forms/RangeShootingReasonForm';
import { useRangeShootingReasonById, useUpdateRangeShootingReason } from '../../../hooks/useRangeShootingReasonApi';
import { useNavigate, useParams } from 'react-router-dom';

const RangeShootingReasonEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { data: entityData } = useRangeShootingReasonById(id);
  const updateMutation = useUpdateRangeShootingReason();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Range Shooting Reasons', href: '/admin/rangeshootingreasons' },
    { label: 'Edit', href: '#' },
  ];

  const handleSubmit = async (data: any) => {
    try {
      await updateMutation.mutateAsync({ id: id!, data });
      navigate('/admin/rangeshootingreasons');
    } catch (error) {
      console.error('Error updating RangeShootingReason:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/rangeshootingreasons"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.RangeShootingReason.Edit'
    >
        {entityData ? (
          <RangeShootingReasonForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/rangeshootingreasons')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default RangeShootingReasonEdit;